<template>
  <div>
    <v-dialog v-model="dialog.phone" persistent max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline">
          Enter Investee's Phone Number
        </v-card-title>
        <v-card-text>
          <v-alert
            :value="alert.search"
            type="error"
            class="mb-3"
            transition="scale-transition"
            outline
            dismissible
          >
            Sorry, no investee found
          </v-alert>
          <v-text-field
            v-model="userPhone"
            v-on:keyup.enter="search"
            required
            label="Phone number"
            ref="userphone"
            prepend-icon="phone"
            prefix="+88"
            counter="11"
            clearable
            :mask="phoneMask"
            :disabled="loading.search"
            :rules="[rules.required, rules.min]"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click="dialog.phone = false">Cancel</v-btn>
          <v-btn
            :disabled="!isValidPhone()"
            color="primary"
            depressed
            @click="search"
            :loading="loading.search"
          >
            <v-icon left>person_search</v-icon>
            Search
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.user" persistent max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline">Please Confirm Investee</v-card-title>
        <v-card-text>
          <p>
            Name:
            <strong>{{ userName }}</strong>
            <br />
            Amount:
            <strong>{{ txnData.tran_amount }}</strong>
            <br />
            EMI:
            <strong>{{ emiTitle }}</strong>
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" dark flat @click="retry">Retry</v-btn>
          <v-btn
            color="green darken-1"
            dark
            depressed
            @click="dialog.user = false"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.submit" persistent max-width="500">
      <v-card class="pa-3">
        <v-card-title class="headline">
          Please Confirm the Details Bellow
        </v-card-title>
        <v-card-text>
          <div v-for="(value, name) in txnData" v-bind:key="name">
            {{ name }}:{{ value }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" dark flat @click="dialog.submit = false">
            Cancel
          </v-btn>
          <v-btn
            color="green darken-1"
            depressed
            disabled
            @click="dialog.submit = false"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.otp" persistent max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline">
          Enter OTP
          <span style="font-size: 13px">
            A 6 digit OTP has been sent to your mobile number.
          </span>
        </v-card-title>
        <v-card-text>
          <v-alert
            :value="alert.otp"
            :type="alert.otpResponse"
            class="mb-3"
            transition="scale-transition"
            outline
            dismissible
          >
            {{ errorMsg }}
          </v-alert>
          <v-text-field
            v-model="txnData.otp"
            v-on:keyup.enter="payEmi"
            required
            label="OTP"
            counter="6"
            clearable
            :disabled="loading.otp || disabled.otp"
            :rules="[rules.required]"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click="dialog.otp = false">Cancel</v-btn>
          <v-btn
            :disabled="!txnData.otp || disabled.otp"
            color="primary"
            depressed
            @click="payEmi"
            :loading="loading.otp"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout ma-4>
      <v-flex xs12 md8 offset-md2>
        <v-card>
          <v-card-title class="indigo white--text headline mt-4">
            <h2>Make a Payment</h2>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs12>
                  <div>
                    <h2 v-if="userName" class="mb-3">
                      <strong>
                        <mark>{{ emiTitle }}</mark>
                      </strong>
                      EMI Payment for
                      <strong>
                        <mark>{{ userName }}</mark>
                      </strong>
                      ### {{ userPhone }}
                    </h2>
                    <v-layout>
                      <v-flex sm6 pr-4>
                        <p>
                          Enter transaction details bellow and click submit.
                        </p>
                      </v-flex>
                      <v-flex sm3>
                        <UploadExcelDialog
                          :apiUrl="paymentApiUrl"
                          @success="initialize"
                          title="Bulk EMI Payment"
                        />
                      </v-flex>
                      <v-flex sm3>
                        <UploadExcelDialog
                          :apiUrl="upfrontPaymentApiUrl"
                          @success="initialize"
                          title="Bulk Upfront Payment"
                        />
                      </v-flex>
                    </v-layout>
                  </div>
                </v-flex>
                <v-flex xs12 class="mt-3">
                  <h3>
                    Autofilled
                    <v-btn color="indigo" fab flat small ma0 @click="retry">
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </h3>
                </v-flex>
                <v-flex md2>
                  <v-text-field
                    v-model="txnData.investee_id"
                    label="Investee ID"
                    required
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex md2>
                  <v-text-field
                    v-model="txnData.loan_id"
                    label="Loan ID"
                    required
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex md2>
                  <v-text-field
                    v-model="txnData.emi_id"
                    label="EMI ID"
                    required
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex md3>
                  <v-text-field
                    v-model="current_emi_due_amount"
                    label="Due Amount"
                    required
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex md3>
                  <v-text-field
                    v-model="txnData.tran_title"
                    label="Transaction Title"
                    required
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex md3>
                  <v-text-field
                    v-model="txnData.tran_status"
                    label="Transaction Status"
                    required
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex md3>
                  <v-text-field
                    v-model="txnData.tran_type"
                    label="Transaction Type"
                    required
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex md3>
                  <v-text-field
                    v-model="txnData.api_connect"
                    label="API Connect"
                    required
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex md3>
                  <v-text-field
                    v-model="txnData.status"
                    label="Status"
                    required
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 class="mt-3">
                  <h3>Input Manually</h3>
                </v-flex>
                <v-flex xs12 class="my-3">
                  <v-alert
                    :value="alert.submit"
                    :type="alert.submitType"
                    class="mb-3"
                    transition="scale-transition"
                    outline
                    dismissible
                  >
                    {{ errorMsg }}
                  </v-alert>
                </v-flex>

                <v-flex md3>
                  <v-select
                    v-model="txnData.payment_type_id"
                    label="Payment Type"
                    :items="paymentTypes"
                    item-text="payment_type"
                    item-value="id"
                    required
                    outline
                    :rules="[rules.required]"
                  ></v-select>
                </v-flex>
                <v-flex md3>
                  <v-select
                    v-model="txnType"
                    label="Transaction Type"
                    :items="types"
                    required
                    outline
                    :readonly="readonly"
                    :rules="[rules.required]"
                    @change="changeTranAmount"
                  ></v-select>
                </v-flex>
                <v-flex md3>
                  <v-text-field
                    v-model="txnData.tran_amount"
                    label="Transaction Amount"
                    required
                    outline
                    :readonly="txnType === 'Full'"
                    :rules="tranAmountRules"
                  ></v-text-field>
                </v-flex>
                <v-flex md3></v-flex>
                <v-flex md3>
                  <v-text-field
                    v-model="txnData.tran_id"
                    label="Transaction ID"
                    required
                    outline
                    :readonly="readonly"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>
                <v-flex md3>
                  <v-text-field
                    v-model="txnData.tran_date"
                    label="Transaction Time"
                    hint="Ex: 2001-12-31 14:30:00"
                    :mask="dateTimeMask"
                    :return-masked-value="true"
                    required
                    outline
                    :readonly="readonly"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>
                <v-flex md3>
                  <v-text-field
                    v-model="txnData.tran_card_no"
                    label="Transaction Card Number"
                    required
                    outline
                    :readonly="readonly"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>
                <v-flex md3>
                  <v-text-field
                    v-model="txnData.bank_tran_id"
                    label="Bank Transaction ID"
                    required
                    outline
                    :readonly="readonly"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions my-3>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs12>
                  <div class="text-xs-center">
                    <v-btn
                      depressed
                      large
                      color="primary"
                      :loading="loading.submit"
                      :disabled="disabled.submit"
                      @click="submit"
                    >
                      Submit
                    </v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
  import { mapGetters } from "vuex";
  import {
    uploadPaymentsExcelUrl,
    upfrontPaymentApiUrl,
  } from "@/utils/variables";
  import UploadExcelDialog from "@/components/Dialogs/UploadExcelDialog";
  import api from "../../api/shadhin";

  export default {
    components: {
      UploadExcelDialog,
    },
    data: () => ({
      paymentApiUrl: uploadPaymentsExcelUrl,
      upfrontPaymentApiUrl,
      dialog: {
        phone: true,
        user: false,
        payment: false,
        submit: false,
        otp: false,
      },

      loading: {
        search: false,
        submit: false,
        otp: false,
      },

      alert: {
        submit: false,
        submitType: "success",
        search: false,
        otp: false,
        otpResponse: "error",
      },

      disabled: {
        submit: false,
        otp: false,
      },

      apiUrl: "admin-emi-pay",

      userName: null,
      userPhone: null,
      emiTitle: null,
      phoneMask: "###########",
      dateTimeMask: "####-##-## ##:##:##",

      txnData: {
        investee_id: null,
        loan_id: null,
        emi_id: null,
        tran_id: null,
        tran_amount: null,
        tran_title: "EMI Paid (Admin)",
        tran_status: "VALID",
        payment_type_id: 3,
        tran_type: "5",
        api_connect: "NULL",
        status: "0",
        tran_date: null,
        tran_card_no: null,
        bank_tran_id: null,
        otp: null,
      },
      txnType: "Full",
      types: ["Full", "Partial"],
      current_emi_due_amount: 0,
      readonly: false,

      paymentTypes: [],
      tranAmountRules: [
        (v) => !!v || "This field is required",
        (v) => (v && v > 0) || "Invalid amount",
      ],
      rules: {
        required: (value) => !!value || "This field is required",
        min: (value) => (value && value.length >= 11) || "Invalid number",
      },
    }),

    computed: {
      ...mapGetters(["isLoggedIn", "indexData", "error", "errorMsg"]),
    },

    created() {
      this.initialize();
      this.tranAmountRules.push(
        (v) =>
          (v && v <= this.current_emi_due_amount) ||
          "Tx. amount exceeds due amount"
      );
    },

    mounted() {
      this.$nextTick(() => this.$refs.userphone.focus());
    },

    methods: {
      async initialize() {
        this.$store.dispatch("resetAll");
        try {
          const token = window.localStorage.getItem("shadhin_token");
          const url = "payment-type";

          const { data } = await api.fetchData(token, url);
          this.paymentTypes = data.data;
        } catch (err) {
          // console.log(err)
        }
      },

      async search() {
        // Exit search if the phone number is invalid
        if (!this.isValidPhone()) {
          return;
        }

        // Enable loading
        this.loading.search = true;

        // Disable alert message if any
        this.alert.search = false;

        // Search for user
        await this.$store.dispatch("searchByDisbursedUser", this.userPhone);

        // Map data
        if (this.error == 0 && this.indexData.data[0] != null) {
          this.alert.submit = false;
          this.readonly = false;
          this.userName = this.indexData.data[0].user_name;
          this.txnData.investee_id = this.indexData.data[0].user_id;
          this.txnData.loan_id = this.indexData.data[0].id;
          this.txnData.emi_id = this.findEMI(this.indexData.data[0].emis);
          this.txnData.tran_amount =
            this.indexData.data[0].current_emi_due_amount;
          this.current_emi_due_amount =
            this.indexData.data[0].current_emi_due_amount;
          this.emiTitle = this.indexData.data[0].current_emi_title;
          // Hide dialog and reset indexData
          this.dialog.phone = false;
          this.dialog.user = true;
          this.disabled.submit = false;
          this.initialize();
        } else {
          this.alert.search = true;
          this.$nextTick(() => this.$refs.userphone.focus());
        }

        // Disable Loading
        this.loading.search = false;
      },

      retry() {
        this.userPhone = null;
        this.dialog.user = false;
        this.dialog.phone = true;
        this.$nextTick(() => this.$refs.userphone.focus());
      },

      findEMI(emis) {
        // console.log(emis);
        // Find the oldest due EMI
        let emi_id = 999999999999;
        for (let emi of emis) {
          if (emi.emi_status_id >= 4 && emi.emi_status_id <= 8) {
            if (emi.id < emi_id) {
              emi_id = emi.id;
              // this.emiTitle = emi.transaction_title;
            }
          }
        }

        return emi_id;
      },

      isValidPhone() {
        return this.$refs.userphone ? this.$refs.userphone.valid : false;
      },

      close() {
        this.dialog = false;
      },

      save() {
        // this.$store.dispatch('store', [this.apiUrl, this.txnData])
        this.close();
      },

      async submit() {
        if (this.hasEmptyField(this.txnData)) {
          alert("All fields are required");
          return;
        }
        this.loading.submit = true;
        // send otp to Logged in Admin
        await this.$store.dispatch("setIndexData", ["sms"]);
        if (this.error == 0) {
          this.alert.submit = false;
          this.alert.otp = false;
          this.txnData.otp = null;
          this.disabled.otp = false;
          this.dialog.otp = true;
        } else {
          this.alert.submitType = "error";
          this.alert.submit = true;
        }

        this.loading.submit = false;

        // this.dialog.submit = true;
      },

      async payEmi() {
        this.loading.otp = true;
        // Store emi data
        await this.$store.dispatch("store", ["admin-emi-pay", this.txnData]);
        if (this.error == 0) {
          this.alert.otpResponse = "success";
          this.disabled.otp = true;
          this.disabled.submit = true;
          this.readonly = true;
        }
        this.alert.otp = true;
        this.loading.otp = false;
      },

      hasEmptyField(fields) {
        for (let [key, value] of Object.entries(fields)) {
          if (key != "otp" && value == null) {
            return true;
          }
        }

        return false;
      },

      changeTranAmount(e) {
        if (e == "Full") {
          this.txnData.tran_amount = this.current_emi_due_amount;
          this.txnData.tran_type = "5";
        } else {
          this.txnData.tran_amount = null;
          this.txnData.tran_type = "7";
        }
      },
    },
  };
</script>
<style scoped>
  #tj-datetime-input {
    min-width: 0px !important;
    height: 58px;
    border-radius: 5px;
  }
</style>
